module.exports = __webpack_public_path__ + "img/dd0p65c-d60628af-615c-44a9-bbd2-1b03043498ff.8b4b96cc.gif";